import { AbgSxProps } from '@abg/typings';

export const actionsContainerStyling: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: '8px',
};

export const amazonCtaButtonStyling = (props: {
  color?: string | undefined;
  isMobile: boolean;
}): AbgSxProps => ({
  width: '100%',
  lineHeight: '14px',
  boxShadow: 'initial !important',
  color: props.color,
  padding: props.isMobile ? '19px 16px' : '15px 16px',
});
